<template>
    <section class="section section--mission">
        <div class="section__image"></div>
        <div class="section__content">
            <VueSlickCarousel v-bind="settings">
                <div class="mission">
                    <Heading text="Naše mise" />
                    <h2 class="mission__heading">Klienti</h2>
                    <ul class="mission__list">
                        <li>Pomáháme lidem poznat sebe sama a tím nacházet své místo v životě.</li>
                        <li>Jsme průvodci na cestě k rozvoji kompetencí potřebných k dosažení vlastních cílů.</li>
                        <li>Prostřednictvím růstu jednotlivce rozvíjíme společnost.</li>
                    </ul>
                    <h2 class="mission__heading">Prostředí</h2>
                    <ul class="mission__list">
                        <li>Svým konáním jsme ohleduplní vůči životnímu prostředí.</li>
                        <li>Naši prosperitu sdílíme s těmi, kteří to nejvíce potřebují.</li>
                    </ul>
                    <h2 class="mission__heading">Pracovníci</h2>
                    <p class="mission__text">Vytváříme prostředí, které podporuje:</p>
                    <ul class="mission__list">
                        <li>osobní i pracovní růst</li>
                        <li>spokojenost a přátelské vztahy</li>
                        <li>work-life balance</li>
                        <li>dosahování úspěchů</li>
                    </ul>
                </div>
                <div class="mission">
                    <Heading text="Jak pracujeme" />
                    <ul class="mission__list">
                        <li>Dbáme na <strong>individuální přístup</strong> a naše řešení jsou ušitá vždy na míru.</li>
                        <li>Pracujeme komplexně a s těmi, kteří mají opravdový <strong>zájem o změnu</strong>.</li>
                        <li>Konzultace probíhají jak osobně, tak online.</li>
                        <li>Nezůstáváme na povrchu, rozvoj probíhá napříč všemi důležitými oblastmi člověka či firmy.</li>
                        <li>Máme lidský, avšak <strong>profesionální přístup</strong>.</li>
                    </ul>
                </div>
                <div class="mission">
                    <Heading text="Naše vize" />
                    <p>Být <strong>kompetentním průvodcem</strong> na cestě za</p>
                    <ul class="mission__list">
                        <li>spokojenějším životem,</li>
                        <li>harmonickými vztahy</li>
                        <li>a pracovními úspěchy</li>
                    </ul>
                    <p><strong>každému, kdo chce růst</strong>.</p>
                </div>
            </VueSlickCarousel>
        </div>
    </section>
</template>

<script>
    import Heading from './includes/Heading.vue';
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

    export default {
        name: 'Mission',
        components: {
            Heading,
            VueSlickCarousel
        },
        data() {
            return {
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .section {

        &__image {
            width: 50%;
            background-image: url('~@/assets/mission.jpg');
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            transition: height .15s ease-in-out;
        }

        &__content {
            width: 50%;
            padding: 6rem;
            transition: height .15s ease-in-out;
        }

        &--mission {
            display: flex;
            padding: 0;
        }
    }

    .mission {

        &__heading {
            text-transform: uppercase;
            font-size: 2rem;
        }

        &__list {
            margin-bottom: 4rem;
            line-height: 1.6;

            li {
                color: #666;

                &:not(:last-of-type) {
                    margin-bottom: .5rem;
                }
            }
        }
    }

    @media (max-width: 999px) {

        .section {

            &__image {
                width: 30%;
            }

            &__content {
                width: 70%;
                padding: 4rem;
            }
        }
    }

    @media (max-width: 767px) {

        .section {

            &__image {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                transform: scale(1.2);
                filter: blur(4px);
            }

            &__content {
                position: relative;
                width: 100%;
                background-color: #fff;
            }

            &--mission {
                position: relative;
                justify-content: center;
                padding: 2rem;
                overflow: hidden;
            }
        }
    }

    @media (max-width: 499px) {

        .section {

            &__content {
                padding: 2rem 2rem 4rem 2rem;
            }
        }
    }

</style>